
import React, { useState, useEffect, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import SourceModal from "./SourceModal";
import { toast } from "react-toastify";
import MeetingModal from "./MeetingModal";
import SourceIcon from "./SourceIcon";
import MarketingTabs from "../AllTabs/MarketingTabs";
import ChatModal from "./ChatModal";
import visaData from "../../VisaData/b2cvisas.json";
import roomTypesData from "../../Data/RoomTypes.json";
import destinationPlacesData from "../../Data/DestinationPlaces.json";
import countriesData from "../../Data/Countries.json";
import {Button, Form, Row, Col, Card, Badge, InputGroup, Spinner } from 'react-bootstrap';
import LeadChat from "./LeadChat"; // Adjust the path based on your folder structure

const initialFieldValues = {
  leadId: "00000000-0000-0000-0000-000000000000",
  leadStatus: "NEW",
  sourceName: "Walk In",
  userId: "00000000-0000-0000-0000-000000000000",
  name: "",
  email: "",
  phoneNumber: "",
  callBack: null,
  enquiryType: "PACKAGE",
  description: "",
  
  // Hotel specific fields
  hotelCity: "",
  hotelCountry: "",
  checkIn: "",
  checkOut: "",
  adults: 1,
  children: 0,
  rooms: 1,
  specialRequests: "",
  roomPreference: "",
  nights: 0,
  
  // Package specific fields
  destination: "",
  checkIn: "",
  checkOut: "",
  adults: 1,
  children: 0,
  packageRequirements: "",
  nights: 0,
  
  // Flight specific fields
  fromCity: "",
  toCity: "",
  departureDate: "",
  returnDate: "",
  adults: 1,
  children: 0,
  classType: "Economy",
  flightRequirements: "",
  
  // Visa specific fields
  visaType: "",
  destinationCountry: "",
  processingTime: "",
  adults: 1,
  children: 0,
  visaRequirements: "",
  
  // Sightseeing specific fields
  sightseeingLocation: "",
  activityType: "",
  sightseeingDate: "",
  adults: 1,
  children: 0,
  requirements: ""
};

// Enquiry Type options
const enquiryTypeOptions = [
  "PACKAGE",
  "GENERAL",
  "FLIGHT",
  "HOTEL",
  "SIGHTSEEING",
  "VISA",
];

// Static Lead Status options
const leadStatusOptions = [
  "NEW",
  "FOLLOW UP",
  "REPLIED",
  "NOT RESPONDING",
  "NOT WORKING",
  "CLOSED",
];

// Custom Hook for Debounce
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

// Get Enquiry Type Color
const getEnquiryTypeColor = (enquiryType) => {
  switch (enquiryType?.toUpperCase()) {
    case "FLIGHT":
      return "bg-soft-primary text-black";
    case "HOTEL":
      return "bg-soft-success text-black";
    case "PACKAGE":
      return "bg-soft-info text-black";
    case "SIGHTSEEING":
      return "bg-soft-warning text-black";
    case "VISA":
      return "bg-soft-danger text-black";
    case "UMRAH":
      return "bg-soft-warning text-black";
    case "HAJJ":
      return "bg-soft-danger text-black";
    default:
      return "bg-soft-secondary text-black";
  }
};

const Lead = () => {
  const { user, loading, refreshUserProfile } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [showChatModal, setShowChatModal] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSourceModal, setShowSourceModal] = useState(false);
  const [source, setSource] = useState([]);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [viewRecord, setViewRecord] = useState(null);
  const [meetings, setMeetings] = useState([]);
  const [isLoadingMeetings, setIsLoadingMeetings] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedLeadForShare, setSelectedLeadForShare] = useState(null);
  const [shareablePackages, setShareablePackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [whatsappMessage, setWhatsappMessage] = useState("");
  const [isLoadingPackages, setIsLoadingPackages] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [selectedPackageDetails, setSelectedPackageDetails] = useState(null);
  const [showVisaSearchModal, setShowVisaSearchModal] = useState(false);
  const [selectedVisa, setSelectedVisa] = useState(null);
  const [visaSearchTerm, setVisaSearchTerm] = useState("");
  const [filteredVisas, setFilteredVisas] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const pdfTemplateRef = useRef(null);
  const [showFollowUpConfirm, setShowFollowUpConfirm] = useState(false);
  const [showFollowUpValidation, setShowFollowUpValidation] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);
  const [showAddCommentModal, setShowAddCommentModal] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [currentLeadForComment, setCurrentLeadForComment] = useState(null);
  const [isAddingComment, setIsAddingComment] = useState(false);
  
  const debouncedSearchKeyword = useDebounce(searchKeyword, 300);
  
  // Auto search states
  const [roomSearchTerm, setRoomSearchTerm] = useState("");
  const [filteredRoomTypes, setFilteredRoomTypes] = useState([]);
  const [showRoomSuggestions, setShowRoomSuggestions] = useState(false);
  
  const [destinationSearchTerm, setDestinationSearchTerm] = useState("");
  const [filteredDestinations, setFilteredDestinations] = useState([]);
  const [showDestinationSuggestions, setShowDestinationSuggestions] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [filteredPlaces, setFilteredPlaces] = useState([]);
  const [showPlaceSuggestions, setShowPlaceSuggestions] = useState(false);
  
  // Hotel city auto search
  const [hotelCitySearchTerm, setHotelCitySearchTerm] = useState("");
  const [filteredHotelCities, setFilteredHotelCities] = useState([]);
  const [showHotelCitySuggestions, setShowHotelCitySuggestions] = useState(false);
  
  // Hotel country auto search
  const [hotelCountrySearchTerm, setHotelCountrySearchTerm] = useState("");
  const [filteredHotelCountries, setFilteredHotelCountries] = useState([]);
  const [showHotelCountrySuggestions, setShowHotelCountrySuggestions] = useState(false);
  
  // Flight city auto search
  const [fromCitySearchTerm, setFromCitySearchTerm] = useState("");
  const [filteredFromCities, setFilteredFromCities] = useState([]);
  const [showFromCitySuggestions, setShowFromCitySuggestions] = useState(false);
  
  const [toCitySearchTerm, setToCitySearchTerm] = useState("");
  const [filteredToCities, setFilteredToCities] = useState([]);
  const [showToCitySuggestions, setShowToCitySuggestions] = useState(false);
  
  // Visa country auto search
  const [visaCountrySearchTerm, setVisaCountrySearchTerm] = useState("");
  const [filteredVisaCountries, setFilteredVisaCountries] = useState([]);
  const [showVisaCountrySuggestions, setShowVisaCountrySuggestions] = useState(false);
  
  // Sightseeing location auto search
  const [sightseeingSearchTerm, setSightseeingSearchTerm] = useState("");
  const [filteredSightseeingLocations, setFilteredSightseeingLocations] = useState([]);
  const [showSightseeingSuggestions, setShowSightseeingSuggestions] = useState(false);

  // Function to get filtered lead status options based on mode
  const getFilteredLeadStatus = () => {
    if (recordForEdit === null) {
      return leadStatusOptions.filter(
        (status) => status === "NEW" || status === "FOLLOW UP"
      );
    }
    return leadStatusOptions;
  };

  // Calculate nights between check-in and check-out dates
  const calculateNights = (checkIn, checkOut) => {
    if (checkIn && checkOut) {
      const start = moment(checkIn);
      const end = moment(checkOut);
      const nights = end.diff(start, 'days');
      return nights > 0 ? nights : 0;
    }
    return 0;
  };

  // Handle check-in/out changes and calculate nights
  useEffect(() => {
    if (values.checkIn && values.checkOut) {
      const nights = calculateNights(values.checkIn, values.checkOut);
      setValues(prev => ({ ...prev, nights }));
    }
  }, [values.checkIn, values.checkOut]);

  // Reset enquiry specific fields when enquiry type changes
  useEffect(() => {
    if (addShow) {
      setValues(prev => ({
        ...prev,
        // Hotel specific
        hotelCity: "",
        hotelCountry: "",
        checkIn: "",
        checkOut: "",
        adults: 1,
        children: 0,
        rooms: 1,
        specialRequests: "",
        roomPreference: "",
        nights: 0,
        
        // Package specific
        destination: "",
        checkIn: "",
        checkOut: "",
        adults: 1,
        children: 0,
        packageRequirements: "",
        nights: 0,
        
        // Flight specific
        fromCity: "",
        toCity: "",
        departureDate: "",
        returnDate: "",
        adults: 1,
        children: 0,
        classType: "Economy",
        flightRequirements: "",
        
        // Visa specific
        visaType: "",
        destinationCountry: "",
        processingTime: "",
        adults: 1,
        children: 0,
        visaRequirements: "",
        
        // Sightseeing specific
        sightseeingLocation: "",
        activityType: "",
        sightseeingDate: "",
        adults: 1,
        children: 0,
        requirements: ""
      }));
      
      // Reset search terms
      setRoomSearchTerm("");
      setDestinationSearchTerm("");
      setHotelCitySearchTerm("");
      setHotelCountrySearchTerm("");
      setFromCitySearchTerm("");
      setToCitySearchTerm("");
      setVisaCountrySearchTerm("");
      setSightseeingSearchTerm("");
      setSelectedPlace(null);
    }
  }, [values.enquiryType, addShow]);

  // Room type search
  const handleRoomSearch = (e) => {
    const query = e.target.value;
    setRoomSearchTerm(query);
    setValues({ ...values, roomPreference: query.toUpperCase() });
    
    if (query.length > 0) {
      const filtered = roomTypesData.roomTypes.filter(room =>
        room.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredRoomTypes(filtered);
      setShowRoomSuggestions(true);
    } else {
      setFilteredRoomTypes([]);
      setShowRoomSuggestions(false);
    }
  };

  const handleRoomSelect = (room) => {
    const roomUpperCase = room.toUpperCase();
    setValues({ ...values, roomPreference: roomUpperCase });
    setRoomSearchTerm(roomUpperCase);
    setShowRoomSuggestions(false);
    setFilteredRoomTypes([]);
  };

  // Destination and place search
  const handleDestinationSearch = (e) => {
    const query = e.target.value;
    setDestinationSearchTerm(query);
    setValues({ ...values, destination: query });
    
    if (query.length > 0) {
      const filteredDests = destinationPlacesData.filter(dest =>
        dest.destination.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredDestinations(filteredDests);
      setShowDestinationSuggestions(true);
      
      const allPlaces = [];
      destinationPlacesData.forEach(dest => {
        dest.places?.forEach(place => {
          if (place.placeName.toLowerCase().includes(query.toLowerCase())) {
            allPlaces.push({
              ...place,
              destinationName: dest.destination
            });
          }
        });
      });
      setFilteredPlaces(allPlaces);
      setShowPlaceSuggestions(true);
    } else {
      setFilteredDestinations([]);
      setFilteredPlaces([]);
      setShowDestinationSuggestions(false);
      setShowPlaceSuggestions(false);
    }
  };

  const handleDestinationSelect = (destination) => {
    setSelectedPlace(null);
    setValues({ ...values, destination: destination.destination });
    setDestinationSearchTerm(destination.destination);
    setShowDestinationSuggestions(false);
    setShowPlaceSuggestions(false);
  };

  const handlePlaceSelect = (place) => {
    setSelectedPlace(place);
    setValues({ ...values, destination: place.placeName });
    setDestinationSearchTerm(place.placeName);
    setShowPlaceSuggestions(false);
    setShowDestinationSuggestions(false);
  };

  // Hotel city search
  const handleHotelCitySearch = (e) => {
    const query = e.target.value;
    setHotelCitySearchTerm(query);
    setValues({ ...values, hotelCity: query });
    
    if (query.length > 0) {
      const allCities = [];
      destinationPlacesData.forEach(dest => {
        dest.places?.forEach(place => {
          if (place.placeName.toLowerCase().includes(query.toLowerCase())) {
            allCities.push({
              ...place,
              country: dest.destination
            });
          }
        });
      });
      setFilteredHotelCities(allCities);
      setShowHotelCitySuggestions(true);
    } else {
      setFilteredHotelCities([]);
      setShowHotelCitySuggestions(false);
    }
  };

  const handleHotelCitySelect = (city) => {
    setValues({ 
      ...values, 
      hotelCity: city.placeName,
      hotelCountry: city.country 
    });
    
    setHotelCitySearchTerm(city.placeName);
    setHotelCountrySearchTerm(city.country);
    
    setShowHotelCitySuggestions(false);
    setFilteredHotelCities([]);
  };

  // Hotel country search
  const handleHotelCountrySearch = (e) => {
    const query = e.target.value;
    setHotelCountrySearchTerm(query);
    setValues({ ...values, hotelCountry: query });
    
    if (query.length > 0) {
      const filtered = countriesData.countries?.filter(country =>
        country.name.toLowerCase().includes(query.toLowerCase())
      ) || [];
      setFilteredHotelCountries(filtered);
      setShowHotelCountrySuggestions(true);
    } else {
      setFilteredHotelCountries([]);
      setShowHotelCountrySuggestions(false);
    }
  };

  const handleHotelCountrySelect = (country) => {
    setValues({ ...values, hotelCountry: country.name });
    setHotelCountrySearchTerm(country.name);
    setShowHotelCountrySuggestions(false);
    setFilteredHotelCountries([]);
  };

  // Flight city search
  const handleFromCitySearch = (e) => {
    const query = e.target.value;
    setFromCitySearchTerm(query);
    setValues({ ...values, fromCity: query });
    
    if (query.length > 0) {
      const allCities = [];
      destinationPlacesData.forEach(dest => {
        dest.places?.forEach(place => {
          if (place.placeName.toLowerCase().includes(query.toLowerCase())) {
            allCities.push(place);
          }
        });
      });
      setFilteredFromCities(allCities);
      setShowFromCitySuggestions(true);
    } else {
      setFilteredFromCities([]);
      setShowFromCitySuggestions(false);
    }
  };

  const handleFromCitySelect = (city) => {
    setValues({ ...values, fromCity: city.placeName });
    setFromCitySearchTerm(city.placeName);
    setShowFromCitySuggestions(false);
    setFilteredFromCities([]);
  };

  const handleToCitySearch = (e) => {
    const query = e.target.value;
    setToCitySearchTerm(query);
    setValues({ ...values, toCity: query });
    
    if (query.length > 0) {
      const allCities = [];
      destinationPlacesData.forEach(dest => {
        dest.places?.forEach(place => {
          if (place.placeName.toLowerCase().includes(query.toLowerCase())) {
            allCities.push(place);
          }
        });
      });
      setFilteredToCities(allCities);
      setShowToCitySuggestions(true);
    } else {
      setFilteredToCities([]);
      setShowToCitySuggestions(false);
    }
  };

  const handleToCitySelect = (city) => {
    setValues({ ...values, toCity: city.placeName });
    setToCitySearchTerm(city.placeName);
    setShowToCitySuggestions(false);
    setFilteredToCities([]);
  };

  // Visa country search
  const handleVisaCountrySearch = (e) => {
    const query = e.target.value;
    setVisaCountrySearchTerm(query);
    setValues({ ...values, destinationCountry: query });
    
    if (query.length > 0) {
      const filtered = countriesData.countries?.filter(country =>
        country.name.toLowerCase().includes(query.toLowerCase())
      ) || [];
      setFilteredVisaCountries(filtered);
      setShowVisaCountrySuggestions(true);
    } else {
      setFilteredVisaCountries([]);
      setShowVisaCountrySuggestions(false);
    }
  };

  const handleVisaCountrySelect = (country) => {
    setValues({ ...values, destinationCountry: country.name });
    setVisaCountrySearchTerm(country.name);
    setShowVisaCountrySuggestions(false);
    setFilteredVisaCountries([]);
  };

  // Sightseeing location search
  const handleSightseeingSearch = (e) => {
    const query = e.target.value;
    setSightseeingSearchTerm(query);
    setValues({ ...values, sightseeingLocation: query });
    
    if (query.length > 0) {
      const allLocations = [];
      destinationPlacesData.forEach(dest => {
        dest.places?.forEach(place => {
          if (place.placeName.toLowerCase().includes(query.toLowerCase())) {
            allLocations.push({
              ...place,
              country: dest.destination
            });
          }
        });
      });
      setFilteredSightseeingLocations(allLocations);
      setShowSightseeingSuggestions(true);
    } else {
      setFilteredSightseeingLocations([]);
      setShowSightseeingSuggestions(false);
    }
  };

  const handleSightseeingSelect = (location) => {
    setValues({ ...values, sightseeingLocation: location.placeName });
    setSightseeingSearchTerm(location.placeName);
    setShowSightseeingSuggestions(false);
    setFilteredSightseeingLocations([]);
  };

  const handleWhatsappClick = async (lead) => {
    if (!user || !user.whatsAppNumber) {
      toast.warn(
        "Please add your WhatsApp number in your profile to use this feature."
      );
      return;
    }

    try {
      const updatedProfile = await refreshUserProfile();

      if (updatedProfile && updatedProfile.connects > 0) {
        handleOpenShareModal(lead);
      } else {
        toast.error(
          "You have no WhatsApp connects left. Please recharge to continue."
        );
      }
    } catch (error) {
      console.error("Failed to refresh user profile:", error);
      toast.error("Could not verify your connects balance. Please try again.");
    }
  };

  const GetData = async (pageNumber) => {
    setIsLoadingData(true);
    let resourceUrl = `${config.GETLEADSBYUSER}/${user.id}?PageNumber=${pageNumber}&PageSize=${pageSize}`;

    if (debouncedSearchKeyword) {
      resourceUrl += `&search=${encodeURIComponent(debouncedSearchKeyword)}`;
    }

    if (filterStatus) {
      resourceUrl += `&leadStatus=${encodeURIComponent(filterStatus)}`;
    }

    try {
      const res = await apiService.getAll(resourceUrl);
      console.log("Fetched leads data:", res);
      if (res.data) {
        setLists(res.data);
        setPageNumber(res.pageNumber);
        setPageSize(res.pageSize);
        setTotalPages(res.totalPages);
        setTotalRecords(res.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
      setLists([]);
      setTotalRecords(0);
      setTotalPages(0);
    } finally {
      setIsLoadingData(false);
    }
  };

  const GetSource = async () => {
    try {
      const res = await apiService.getAll(`${config.GETSOURCE}`);
      setSource(res.data);
    } catch (error) {
      console.error("Error fetching sources:", error);
      setSource([]);
    }
  };

  useEffect(() => {
    if (user && !loading) {
      GetSource();
      GetData(1);
    }
  }, [user?.cid, loading]);

  useEffect(() => {
    if (user && !loading) {
      setPageNumber(1);
      GetData(1);
    }
  }, [debouncedSearchKeyword, filterStatus]);

  useEffect(() => {
    if (recordForEdit !== null) {
      let updatedValues = { ...recordForEdit };
      
      if (recordForEdit.serviceDetails && typeof recordForEdit.serviceDetails === 'object') {
        updatedValues = {
          ...updatedValues,
          ...recordForEdit.serviceDetails
        };
      }
      
      setValues(updatedValues);
      
      if (recordForEdit.enquiryType === "HOTEL") {
        setHotelCitySearchTerm(recordForEdit.serviceDetails?.city || recordForEdit.hotelCity || "");
        setHotelCountrySearchTerm(recordForEdit.serviceDetails?.country || recordForEdit.hotelCountry || "");
        setRoomSearchTerm(recordForEdit.serviceDetails?.roomPreference || recordForEdit.roomPreference || "");
      } else if (recordForEdit.enquiryType === "PACKAGE") {
        setDestinationSearchTerm(recordForEdit.serviceDetails?.destination || recordForEdit.destination || "");
      } else if (recordForEdit.enquiryType === "FLIGHT") {
        setFromCitySearchTerm(recordForEdit.serviceDetails?.from || recordForEdit.fromCity || "");
        setToCitySearchTerm(recordForEdit.serviceDetails?.to || recordForEdit.toCity || "");
      } else if (recordForEdit.enquiryType === "VISA") {
        setVisaCountrySearchTerm(recordForEdit.serviceDetails?.destinationCountry || recordForEdit.destinationCountry || "");
      } else if (recordForEdit.enquiryType === "SIGHTSEEING") {
        setSightseeingSearchTerm(recordForEdit.serviceDetails?.location || recordForEdit.sightseeingLocation || "");
      }
    } else {
      setValues({ ...initialFieldValues, userId: user?.id });
    }
  }, [recordForEdit, user]);

  const handleAddShow = () => {
    setRecordForEdit(null);
    setValues({ ...initialFieldValues, enquiryType: "PACKAGE" });
    setErrors({});
    setAddShow(true);
  };

  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
    setRoomSearchTerm("");
    setDestinationSearchTerm("");
    setSelectedPlace(null);
    setHotelCitySearchTerm("");
    setHotelCountrySearchTerm("");
    setFromCitySearchTerm("");
    setToCitySearchTerm("");
    setVisaCountrySearchTerm("");
    setSightseeingSearchTerm("");
  };

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setErrors({});
    setAddShow(true);
  };

  const showViewDetails = async (lead) => {
    setViewRecord(lead);
    setShowViewModal(true);
    await fetchLeadComments(lead.leadId);
  };

  const fetchLeadComments = async (leadId) => {
    setIsLoadingMeetings(true);
    try {
      const response = await apiService.getById(
        `${config.GETLEADBYID}`,
        `${leadId}`
      );
      
      if (response.data && response.data.history) {
        setMeetings(response.data.history);
      } else {
        setMeetings([]);
      }
    } catch (err) {
      console.error("Error fetching lead details:", err);
      setMeetings([]);
    } finally {
      setIsLoadingMeetings(false);
    }
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETELEAD, itemToDelete);
        await GetData();
      } catch (error) {
        /* Handled by apiService */
      }
      handleCloseDeleteModal();
    }
  };

  const handleOpenShareModal = (lead) => {
    if (lead.enquiryType === "FLIGHT") {
      navigate("/flight/search");
      return;
    }

    setSelectedLeadForShare(lead);
    setShowShareModal(true);
    setShareablePackages([]);
    setSelectedPackage(null);
    setWhatsappMessage("");
    setSearchTerm("");
    setSelectedVisa(null);
    setSelectedCountry(null);
  };

  const handleCloseShareModal = () => {
    setShowShareModal(false);
    setSelectedLeadForShare(null);
  };

  const getPackagesForSharing = async () => {
    if (!selectedLeadForShare) return;

    setIsLoadingPackages(true);
    try {
      const packageTypeForAPI =
        selectedLeadForShare.enquiryType === "PACKAGE"
          ? "Holiday"
          : selectedLeadForShare.enquiryType;

      const resourceUrl = `${config.GETPACKAGEBYCOMAPANYID}/${user.cid}?type=${packageTypeForAPI}&searchText=${searchTerm}`;

      const res = await apiService.getAll(resourceUrl);
      if (res.data) {
        setShareablePackages(res.data);
      } else {
        setShareablePackages([]);
      }
    } catch (error) {
      console.error("Error fetching packages for sharing:", error);
      setShareablePackages([]);
    } finally {
      setIsLoadingPackages(false);
    }
  };

  useEffect(() => {
    if (showShareModal && selectedLeadForShare?.enquiryType !== "VISA") {
      getPackagesForSharing();
    }
  }, [showShareModal, searchTerm, selectedLeadForShare]);

  const handlePackageSelect = async (pkg) => {
    setSelectedPackage(pkg);
    setSelectedVisa(null);
    setSelectedPackageDetails(null);

    try {
      const fullDetails = await apiService.get(
        `${config.GETPACKAGEDETAILS}/${pkg.packageId}`
      );
      setSelectedPackageDetails(fullDetails);
    } catch (error) {
      console.error("Failed to fetch full package details:", error);
    }

    const packageLink = `https://b2c.zotrai.com/holiday-details/62765038-1f58-46b1-a872-0cb7673d1cc0`;

    const message = `Hello ${
      selectedLeadForShare?.name
    },\n\nGreetings!\n\nAs per our discussion, here is an exciting offer for you:\n\n*${
      pkg.packageName
    }*\nDuration: ${pkg.duration}\nPrice: ${
      pkg.currency
    } ${pkg.price.toLocaleString()} per person\n\nView details here: ${packageLink}\n\nLet us know if you're interested!\n\nBest Regards,\n${
      user.name
    }`;

    setWhatsappMessage(message);
  };

  const handleVisaSelect = (visa) => {
    setSelectedVisa(visa);
    setSelectedPackage(null);
    setSelectedPackageDetails(null);

    const message = `Hello ${
      selectedLeadForShare?.name
    },\n\nGreetings!\n\nAs per our discussion, here is the visa information you requested:\n\n*${
      visa.visaName
    }*\nCountry: ${selectedCountry.name}\nType: ${visa.visaType}\nEntry: ${
      visa.entry
    }\nStay Period: ${visa.stayPeriod}\nValidity: ${
      visa.validity
    }\nPrice: ${parseFloat(
      visa.adultPrice
    )} INR\n\nLet us know if you're interested!\n\nBest Regards,\n${user.name}`;

    setWhatsappMessage(message);
  };

  const handleVisaSearch = (e) => {
    const query = e.target.value;
    setVisaSearchTerm(query);

    if (query.length > 0) {
      const filtered = visaData.filter((item) =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredVisas(filtered);
    } else {
      setFilteredVisas([]);
    }
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setVisaSearchTerm(country.name);
    setFilteredVisas([]);
  };

  const handleSendWhatsapp = async () => {
    if ((!selectedPackageDetails && !selectedVisa) || !selectedLeadForShare) {
      return;
    }

    setIsSending(true);

    try {
      let pdfFile = null;

      if (selectedPackageDetails) {
        const input = pdfTemplateRef.current;
        const canvas = await html2canvas(input, { scale: 1 });
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const ratio = canvasHeight / canvasWidth;

        const imgHeight = pdfWidth * ratio;
        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;

        while (heightLeft > 0) {
          position = position - pdfHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
          heightLeft -= pdfHeight;
        }

        const pdfBlob = pdf.output("blob");
        pdfFile = new File([pdfBlob], `${selectedPackage.packageName}.pdf`, {
          type: "application/pdf",
        });
      } else if (selectedVisa) {
        const pdf = new jsPDF();

        pdf.setFontSize(16);
        pdf.text(`Visa Details: ${selectedVisa.visaName}`, 20, 20);
        pdf.setFontSize(12);
        pdf.text(`Country: ${selectedVisa.visaCountryName}`, 20, 30);
        pdf.text(`Type: ${selectedVisa.visaType}`, 20, 40);
        pdf.text(`Entry: ${selectedVisa.entry}`, 20, 50);
        pdf.text(`Stay Period: ${selectedVisa.stayPeriod}`, 20, 60);
        pdf.text(`Validity: ${selectedVisa.validity}`, 20, 70);
        pdf.text(
          `Price: ${
            parseFloat(selectedVisa.adultPrice) +
            parseFloat(selectedVisa.serviceFee)
          } INR`,
          20,
          80
        );

        const pdfBlob = pdf.output("blob");
        pdfFile = new File([pdfBlob], `${selectedVisa.visaName}.pdf`, {
          type: "application/pdf",
        });
      }

      const formData = new FormData();
      const phoneNumber = selectedLeadForShare.phoneNumber;
      const formattedPhoneNumber = phoneNumber.startsWith("91")
        ? phoneNumber
        : "91" + phoneNumber;
      formData.append("CustomerPhone", formattedPhoneNumber);
      formData.append("CustomerName", selectedLeadForShare.name);
      formData.append("Caption", whatsappMessage);
      formData.append("CompanyId", user.cid);
      if (pdfFile) {
        formData.append("PdfFile", pdfFile);
      }

      await apiService.postWithFile(`${config.SENDPDF}`, formData);
      await refreshUserProfile();
      handleCloseShareModal();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to send WhatsApp message. Please try again.";

      toast.error(errorMessage);
      handleCloseShareModal();
    } finally {
      setIsSending(false);
    }
  };

  const handleSourceSubmit = () => {
    GetSource();
    setShowSourceModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "callBack") {
      setValues({ ...values, [name]: value === "" ? null : value });
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    const numValue = parseInt(value) || 0;
    setValues({ ...values, [name]: numValue });
  };

  // Function to add comment message - ONLY CALLED WHEN USER ADDS A COMMENT
  const addCommentMessage = async (leadId, comment, leadStatus) => {
    try {
      const messageData = {
        leadId: leadId,
        newLog: {
          userId: user?.id,
          userName: user?.name,
          status: leadStatus || "COMMENT",
          message: comment,
          createdDate: new Date().toISOString()
        }
      };
      
      await apiService.put(`${config.UPDATELEADSTATUS}`, messageData);
      return true;
    } catch (error) {
      console.error("Error adding comment:", error);
      return false;
    }
  };

  // Function to add follow-up chat message
  const addFollowUpChatMessage = async (leadId, followUpDate) => {
    try {
      const formattedDate = moment(followUpDate).format("DD MMM YYYY, hh:mm A");
      const messageData = {
        leadId: leadId,
        newLog: {
          userId: user?.id,
          userName: user?.name,
          status: "FOLLOW UP",
          message: `Follow-up scheduled for ${formattedDate}`,
          createdDate: new Date().toISOString()
        }
      };
      
      await apiService.put(`${config.UPDATELEADSTATUS}`, messageData);
    } catch (error) {
      console.error("Error adding follow-up chat message:", error);
    }
  };

  // Function to add status change message
  const addStatusChangeMessage = async (leadId, oldStatus, newStatus) => {
    try {
      const messageData = {
        leadId: leadId,
        newLog: {
          userId: user?.id,
          userName: user?.name,
          status: newStatus,
          message: `Status changed from ${oldStatus} to ${newStatus}`,
          createdDate: new Date().toISOString()
        }
      };
      
      await apiService.put(`${config.UPDATELEADSTATUS}`, messageData);
    } catch (error) {
      console.error("Error adding status change message:", error);
    }
  };

  // Function to get service details based on enquiry type
  const getServiceDetailsForEnquiryType = () => {
    let serviceDetails = {};

    switch(values.enquiryType?.toUpperCase()) {
      case "HOTEL":
        serviceDetails = {
          city: values.hotelCity,
          country: values.hotelCountry,
          checkIn: values.checkIn,
          checkOut: values.checkOut,
          adults: values.adults,
          children: values.children,
          rooms: values.rooms,
          nights: values.nights,
          specialRequests: values.specialRequests,
          roomPreference: values.roomPreference,
          totalGuests: parseInt(values.adults) + parseInt(values.children)
        };
        break;
      
      case "PACKAGE":
        serviceDetails = {
          destination: values.destination,
          checkIn: values.checkIn,
          checkOut: values.checkOut,
          adults: values.adults,
          children: values.children,
          nights: values.nights,
          requirements: values.packageRequirements
        };
        break;
      
      case "FLIGHT":
        serviceDetails = {
          from: values.fromCity,
          to: values.toCity,
          departureDate: values.departureDate,
          returnDate: values.returnDate,
          adults: values.adults,
          children: values.children,
          classType: values.classType,
          requirements: values.flightRequirements
        };
        break;
      
      case "VISA":
        serviceDetails = {
          visaType: values.visaType,
          destinationCountry: values.destinationCountry,
          processingTime: values.processingTime,
          adults: values.adults,
          children: values.children,
          requirements: values.visaRequirements
        };
        break;
      
      case "SIGHTSEEING":
        serviceDetails = {
          location: values.sightseeingLocation,
          activityType: values.activityType,
          date: values.sightseeingDate,
          adults: values.adults,
          children: values.children,
          requirements: values.requirements
        };
        break;
      
      default:
        break;
    }

    return serviceDetails;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const isFollowUpStatus = values.leadStatus
        ?.toLowerCase()
        .includes("follow up");
      const isNewLead = values.leadId === "00000000-0000-0000-0000-000000000000";

      // Store old status for status change message
      const oldStatus = recordForEdit?.leadStatus || null;

      if (isFollowUpStatus) {
        if (!values.callBack || values.callBack === "0001-01-01T00:00:00") {
          setShowFollowUpValidation(true);
          return;
        } else {
          setPendingFormData({
            leadId: values.leadId,
            leadStatus: values.leadStatus,
            sourceName: values.sourceName,
            userId: user?.id,
            name: values.name,
            email: values.email,
            phoneNumber: values.phoneNumber,
            callBack: values.callBack,
            enquiryType: values.enquiryType,
            description: values.description,
            serviceDetails: getServiceDetailsForEnquiryType(),
            senderId: null,
            receiverId: user?.id,
            senderDetails: {},
            receiverDetails: {
              userId: user?.id,
              companyName: user?.companyname || "",
              receiverName: user?.name || "",
              receiverEmail: user?.email || "",
              receiverPhone: user?.phoneNumber || ""
            },
            createdDate: recordForEdit?.createdDate || new Date().toISOString(),
            updatedDate: new Date().toISOString(),
            oldStatus: oldStatus // Store old status for later use
          });
          setShowFollowUpConfirm(true);
          return;
        }
      }

      await submitFormData(isNewLead, oldStatus);
    }
  };

  const submitFormData = async (isNewLead = false, oldStatus = null) => {
    setBtnLoading(true);

    const serviceDetails = getServiceDetailsForEnquiryType();

    const formData = pendingFormData || {
      leadId: values.leadId,
      leadStatus: values.leadStatus || "NEW",
      sourceName: values.sourceName,
      userId: user?.id,
      name: values.name,
      email: values.email,
      phoneNumber: values.phoneNumber,
      callBack: values.callBack,
      enquiryType: values.enquiryType,
      description: values.description,
      serviceDetails: serviceDetails,
      senderId: null,
      receiverId: user?.id,
      senderStatus: "Pending",
      senderTime: new Date().toISOString(),
      receiverStatus: "Pending",
      receiverTime: null,
      senderDetails: {},
      receiverDetails: {
        userId: user?.id,
        companyName: user?.companyname || "",
        receiverName: user?.name || "",
        receiverEmail: user?.email || "",
        receiverPhone: user?.phoneNumber || ""
      },
      createdDate: recordForEdit?.createdDate || new Date().toISOString(),
      updatedDate: new Date().toISOString()
    };

    try {
      const response = await apiService.put(config.UPDATELEAD, formData);
      
      // Get the lead ID from response or use the form data
      const savedLeadId = response.data?.leadId || formData.leadId;
      
      // Only add status change and follow-up messages - NOT lead creation message
      if (!isNewLead) {
        // Check if status has changed (for existing leads only)
        const currentOldStatus = oldStatus || recordForEdit?.leadStatus;
        if (currentOldStatus && currentOldStatus !== formData.leadStatus) {
          // Add status change message
          await addStatusChangeMessage(savedLeadId, currentOldStatus, formData.leadStatus);
        }
      }
      
      // Check if this is a follow-up status (for both new and existing leads)
      const isFollowUpStatus = formData.leadStatus?.toLowerCase().includes("follow up");
      if (isFollowUpStatus && formData.callBack) {
        // Add follow-up chat message
        await addFollowUpChatMessage(savedLeadId, formData.callBack);
      }
      
      toast.success(
        isNewLead
          ? "Lead created successfully!"
          : "Lead updated successfully!"
      );
      
      await GetData(pageNumber);
      resetForm();
      setShowFollowUpConfirm(false);
      setShowFollowUpValidation(false);
      setPendingFormData(null);
    } catch (error) {
      console.error("Error saving lead:", error);
      toast.error("Failed to save lead. Please try again.");
    } finally {
      setBtnLoading(false);
    }
  };

  const handleConfirmFollowUp = () => {
    const isNewLead = pendingFormData?.leadId === "00000000-0000-0000-0000-000000000000";
    const oldStatus = pendingFormData?.oldStatus || recordForEdit?.leadStatus;
    submitFormData(isNewLead, oldStatus);
  };

  const handleCancelFollowUp = () => {
    setShowFollowUpConfirm(false);
    setPendingFormData(null);
    setBtnLoading(false);
  };

  const handleCloseValidationModal = () => {
    setShowFollowUpValidation(false);
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
    setRecordForEdit(null);
  };

  const handleReset = () => {
    setSearchKeyword("");
    setFilterStatus("");
    setPageNumber(1);
  };

  const handleCommentAdded = () => {
    setShowMeetingModal(false);
    GetData(pageNumber);
  };

  // Function to open add comment modal
  const handleOpenAddComment = (lead) => {
    setCurrentLeadForComment(lead);
    setCommentText("");
    setShowAddCommentModal(true);
  };

  // Function to handle comment submission - ONLY CALLED WHEN USER ADDS A COMMENT
  const handleSubmitComment = async () => {
    if (!commentText.trim()) {
      toast.warn("Please enter a comment");
      return;
    }

    if (!currentLeadForComment) return;

    setIsAddingComment(true);
    try {
      const success = await addCommentMessage(
        currentLeadForComment.leadId, 
        commentText,
        currentLeadForComment.leadStatus // Pass the current lead status
      );
      
      if (success) {
        toast.success("Comment added successfully");
        setShowAddCommentModal(false);
        setCommentText("");
        
        // Refresh comments if view modal is open for the same lead
        if (viewRecord && viewRecord.leadId === currentLeadForComment.leadId) {
          await fetchLeadComments(currentLeadForComment.leadId);
        }
      } else {
        toast.error("Failed to add comment");
      }
    } catch (error) {
      console.error("Error adding comment:", error);
      toast.error("Failed to add comment");
    } finally {
      setIsAddingComment(false);
    }
  };

  const validate = () => {
    let temp = {};
    temp.name = /^[A-Za-z\s]+$/.test(values.name.trim());
    temp.phoneNumber = /^\d{7,14}$/.test(values.phoneNumber);
    temp.followUp = true;

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const getStatusColor = (leadStatusName) => {
    const name = leadStatusName?.toLowerCase();

    if (name?.includes("new")) return "badge bg-primary text-white";
    if (name?.includes("replied")) return "badge bg-secondary text-white";
    if (name?.includes("closed")) return "badge bg-success text-white";
    if (name?.includes("not responding")) return "badge bg-danger text-white";
    if (name?.includes("follow up")) return "badge bg-warning text-white";
    if (name?.includes("not working")) return "badge bg-info text-white";

    return "badge bg-light text-dark";
  };

  const GetFirstPageData = () => {
    setPageNumber(1);
  };

  const GetLastPageData = () => {
    setPageNumber(totalPages);
  };

  const handleGeneratePackage = () => {
    navigate("/package");
  };

  const GetPageData = (number) => {
    if (number > 0 && number <= totalPages) {
      setPageNumber(number);
    }
  };
  const handleViewModalCommentSubmit = async () => {
    if (!commentText.trim()) {
        toast.warn("Please enter a comment");
        return;
    }

    setIsAddingComment(true);
    const payload = {
        leadId: viewRecord.leadId,
        leadStatus: viewRecord.leadStatus,
        newLog: {
            userId: user.id,
            userName: user.name,
            status: viewRecord.leadStatus,
            message: commentText,
            createdDate: new Date().toISOString()
        }
    };

    try {
        await apiService.update(config.UPDATE_LEAD_STATUS, payload);
        setCommentText("");
        await fetchLeadComments(viewRecord.leadId);
        // Also refresh main list to keep counts accurate
        GetData(pageNumber); 
    } catch (error) {
        console.error("Error adding comment:", error);
        toast.error("Failed to add comment");
    } finally {
        setIsAddingComment(false);
    }
}

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, pageNumber - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <>
        {startPage > 1 && (
          <>
            <li className="page-item" onClick={() => GetPageData(1)}>
              <Link to="#" className="page-link">
                1
              </Link>
            </li>
            {startPage > 2 && (
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            )}
          </>
        )}

        {pageNumbers.map((number) => (
          <li
            className={`page-item ${pageNumber === number ? "active" : ""}`}
            key={number}
            onClick={() => GetPageData(number)}
          >
            <Link to="#" className="page-link">
              {number}
            </Link>
          </li>
        ))}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && (
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            )}
            <li className="page-item" onClick={() => GetPageData(totalPages)}>
              <Link to="#" className="page-link">
                {totalPages}
              </Link>
            </li>
          </>
        )}
      </>
    );
  };

  useEffect(() => {
    if (user && !loading && pageNumber > 0) {
      GetData(pageNumber);
    }
  }, [pageNumber, debouncedSearchKeyword, filterStatus, user?.cid, loading]);

  // Render enquiry type specific form fields
  const renderEnquirySpecificFields = () => {
    switch(values.enquiryType?.toUpperCase()) {
      case "HOTEL":
        return (
          <div className="card border-primary mb-3 mt-3">
            <div className="card-header bg-primary bg-opacity-10">
              <h6 className="mb-0 text-primary">Hotel Details</h6>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-4 position-relative">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="hotelCity"
                    value={hotelCitySearchTerm}
                    onChange={handleHotelCitySearch}
                    onFocus={() => {
                      if (filteredHotelCities.length > 0) {
                        setShowHotelCitySuggestions(true);
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowHotelCitySuggestions(false), 200);
                    }}
                    placeholder="Search for city..."
                    autoComplete="off"
                  />
                  {showHotelCitySuggestions && filteredHotelCities.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                      {filteredHotelCities.map((city, index) => (
                        <button
                          key={index}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleHotelCitySelect(city)}
                        >
                          <strong>{city.placeName}</strong>
                          <small className="d-block text-muted">{city.country}</small>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="col-md-4 position-relative">
                  <label className="form-label">Country</label>
                  <input
                    type="text"
                    className="form-control"
                    name="hotelCountry"
                    value={hotelCountrySearchTerm}
                    onChange={handleHotelCountrySearch}
                    onFocus={() => {
                      if (filteredHotelCountries.length > 0) {
                        setShowHotelCountrySuggestions(true);
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowHotelCountrySuggestions(false), 200);
                    }}
                    placeholder="Search for country..."
                    autoComplete="off"
                    readOnly={hotelCountrySearchTerm ? true : false}
                  />
                  {showHotelCountrySuggestions && filteredHotelCountries.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                      {filteredHotelCountries.map((country, index) => (
                        <button
                          key={index}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleHotelCountrySelect(country)}
                        >
                          {country.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">Rooms</label>
                  <input
                    type="number"
                    className="form-control"
                    name="rooms"
                    value={values.rooms}
                    onChange={handleNumberChange}
                    min="1"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Check-in Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="checkIn"
                    value={values.checkIn}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Check-out Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="checkOut"
                    value={values.checkOut}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Nights</label>
                  <input
                    type="number"
                    className="form-control"
                    name="nights"
                    value={values.nights}
                    readOnly
                    disabled
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Adults</label>
                  <input
                    type="number"
                    className="form-control"
                    name="adults"
                    value={values.adults}
                    onChange={handleNumberChange}
                    min="1"
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Children</label>
                  <input
                    type="number"
                    className="form-control"
                    name="children"
                    value={values.children}
                    onChange={handleNumberChange}
                    min="0"
                  />
                </div>
                <div className="col-12 position-relative">
                  <label className="form-label">Room Preference (Optional)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="roomPreference"
                    value={roomSearchTerm}
                    onChange={handleRoomSearch}
                    onFocus={() => {
                      if (filteredRoomTypes.length > 0) {
                        setShowRoomSuggestions(true);
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowRoomSuggestions(false), 200);
                    }}
                    placeholder="Search for room type..."
                    autoComplete="off"
                  />
                  {showRoomSuggestions && filteredRoomTypes.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                      {filteredRoomTypes.map((room, index) => (
                        <button
                          key={index}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleRoomSelect(room)}
                        >
                          {room.toUpperCase()}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="col-12">
                  <label className="form-label">Special Requests</label>
                  <textarea
                    className="form-control"
                    name="specialRequests"
                    value={values.specialRequests}
                    onChange={handleInputChange}
                    placeholder="Any special requirements or requests"
                    rows="2"
                  />
                </div>
              </div>
            </div>
          </div>
        );
      
      case "PACKAGE":
        return (
          <div className="card border-success mb-3 mt-3">
            <div className="card-header bg-success bg-opacity-10">
              <h6 className="mb-0 text-success">Package Details</h6>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6 position-relative">
                  <label className="form-label">Destination / City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="destination"
                    value={destinationSearchTerm}
                    onChange={handleDestinationSearch}
                    onFocus={() => {
                      if (filteredDestinations.length > 0 || filteredPlaces.length > 0) {
                        setShowDestinationSuggestions(true);
                        setShowPlaceSuggestions(true);
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        setShowDestinationSuggestions(false);
                        setShowPlaceSuggestions(false);
                      }, 200);
                    }}
                    placeholder="Search for destination or city..."
                    autoComplete="off"
                  />
                  {showDestinationSuggestions && filteredDestinations.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                      <div className="list-group-item bg-light fw-bold">Destinations</div>
                      {filteredDestinations.map((dest) => (
                        <button
                          key={dest.destinationId}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleDestinationSelect(dest)}
                        >
                          <strong>{dest.destination}</strong>
                          <small className="d-block text-muted">{dest.description?.substring(0, 60)}...</small>
                        </button>
                      ))}
                    </div>
                  )}
                  {showPlaceSuggestions && filteredPlaces.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto', top: '100%' }}>
                      <div className="list-group-item bg-light fw-bold">Cities</div>
                      {filteredPlaces.map((place) => (
                        <button
                          key={place.placeId}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handlePlaceSelect(place)}
                        >
                          <strong>{place.placeName}</strong>
                          <small className="d-block text-muted">{place.destinationName || place.country}</small>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="checkIn"
                    value={values.checkIn}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="checkOut"
                    value={values.checkOut}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Nights</label>
                  <input
                    type="number"
                    className="form-control"
                    name="nights"
                    value={values.nights}
                    readOnly
                    disabled
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Adults</label>
                  <input
                    type="number"
                    className="form-control"
                    name="adults"
                    value={values.adults}
                    onChange={handleNumberChange}
                    min="1"
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Children</label>
                  <input
                    type="number"
                    className="form-control"
                    name="children"
                    value={values.children}
                    onChange={handleNumberChange}
                    min="0"
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Package Requirements</label>
                  <textarea
                    className="form-control"
                    name="packageRequirements"
                    value={values.packageRequirements}
                    onChange={handleInputChange}
                    placeholder="Describe your package requirements, inclusions, budget, etc."
                    rows="2"
                  />
                </div>
              </div>
            </div>
          </div>
        );
      
      case "FLIGHT":
        return (
          <div className="card border-info mb-3 mt-3">
            <div className="card-header bg-info bg-opacity-10">
              <h6 className="mb-0 text-info">Flight Details</h6>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6 position-relative">
                  <label className="form-label">From City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="fromCity"
                    value={fromCitySearchTerm}
                    onChange={handleFromCitySearch}
                    onFocus={() => {
                      if (filteredFromCities.length > 0) {
                        setShowFromCitySuggestions(true);
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowFromCitySuggestions(false), 200);
                    }}
                    placeholder="Departure city"
                    autoComplete="off"
                  />
                  {showFromCitySuggestions && filteredFromCities.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                      {filteredFromCities.map((city, index) => (
                        <button
                          key={index}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleFromCitySelect(city)}
                        >
                          <strong>{city.placeName}</strong>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="col-md-6 position-relative">
                  <label className="form-label">To City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="toCity"
                    value={toCitySearchTerm}
                    onChange={handleToCitySearch}
                    onFocus={() => {
                      if (filteredToCities.length > 0) {
                        setShowToCitySuggestions(true);
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowToCitySuggestions(false), 200);
                    }}
                    placeholder="Arrival city"
                    autoComplete="off"
                  />
                  {showToCitySuggestions && filteredToCities.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                      {filteredToCities.map((city, index) => (
                        <button
                          key={index}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleToCitySelect(city)}
                        >
                          <strong>{city.placeName}</strong>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Departure Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="departureDate"
                    value={values.departureDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Return Date (Optional)</label>
                  <input
                    type="date"
                    className="form-control"
                    name="returnDate"
                    value={values.returnDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Adults</label>
                  <input
                    type="number"
                    className="form-control"
                    name="adults"
                    value={values.adults}
                    onChange={handleNumberChange}
                    min="1"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Children</label>
                  <input
                    type="number"
                    className="form-control"
                    name="children"
                    value={values.children}
                    onChange={handleNumberChange}
                    min="0"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Class</label>
                  <select
                    className="form-select"
                    name="classType"
                    value={values.classType}
                    onChange={handleInputChange}
                  >
                    <option value="Economy">Economy</option>
                    <option value="Premium Economy">Premium Economy</option>
                    <option value="Business">Business</option>
                    <option value="First">First</option>
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label">Flight Requirements</label>
                  <textarea
                    className="form-control"
                    name="flightRequirements"
                    value={values.flightRequirements}
                    onChange={handleInputChange}
                    placeholder="Any specific airline preferences, timing preferences, etc."
                    rows="2"
                  />
                </div>
              </div>
            </div>
          </div>
        );
      
      case "VISA":
        return (
          <div className="card border-warning mb-3 mt-3">
            <div className="card-header bg-warning bg-opacity-10">
              <h6 className="mb-0 text-warning">Visa Details</h6>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Visa Type</label>
                  <select
                    className="form-select"
                    name="visaType"
                    value={values.visaType}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Visa Type</option>
                    <option value="Tourist">Tourist Visa</option>
                    <option value="Business">Business Visa</option>
                    <option value="Student">Student Visa</option>
                    <option value="Work">Work Visa</option>
                    <option value="Transit">Transit Visa</option>
                    <option value="Medical">Medical Visa</option>
                  </select>
                </div>
                <div className="col-md-6 position-relative">
                  <label className="form-label">Destination Country</label>
                  <input
                    type="text"
                    className="form-control"
                    name="destinationCountry"
                    value={visaCountrySearchTerm}
                    onChange={handleVisaCountrySearch}
                    onFocus={() => {
                      if (filteredVisaCountries.length > 0) {
                        setShowVisaCountrySuggestions(true);
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowVisaCountrySuggestions(false), 200);
                    }}
                    placeholder="Search for country..."
                    autoComplete="off"
                  />
                  {showVisaCountrySuggestions && filteredVisaCountries.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                      {filteredVisaCountries.map((country, index) => (
                        <button
                          key={index}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleVisaCountrySelect(country)}
                        >
                          {country.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Required Processing Time</label>
                  <input
                    type="text"
                    className="form-control"
                    name="processingTime"
                    value={values.processingTime}
                    onChange={handleInputChange}
                    placeholder="e.g., Urgent (3-5 days), Normal (10-15 days)"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Adults</label>
                  <input
                    type="number"
                    className="form-control"
                    name="adults"
                    value={values.adults}
                    onChange={handleNumberChange}
                    min="1"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Children</label>
                  <input
                    type="number"
                    className="form-control"
                    name="children"
                    value={values.children}
                    onChange={handleNumberChange}
                    min="0"
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Visa Requirements / Notes</label>
                  <textarea
                    className="form-control"
                    name="visaRequirements"
                    value={values.visaRequirements}
                    onChange={handleInputChange}
                    placeholder="Any specific requirements, previous visa history, etc."
                    rows="2"
                  />
                </div>
              </div>
            </div>
          </div>
        );
      
      case "SIGHTSEEING":
        return (
          <div className="card border-secondary mb-3 mt-3">
            <div className="card-header bg-secondary bg-opacity-10">
              <h6 className="mb-0 text-secondary">Sightseeing Details</h6>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6 position-relative">
                  <label className="form-label">Location</label>
                  <input
                    type="text"
                    className="form-control"
                    name="sightseeingLocation"
                    value={sightseeingSearchTerm}
                    onChange={handleSightseeingSearch}
                    onFocus={() => {
                      if (filteredSightseeingLocations.length > 0) {
                        setShowSightseeingSuggestions(true);
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowSightseeingSuggestions(false), 200);
                    }}
                    placeholder="Search for location..."
                    autoComplete="off"
                  />
                  {showSightseeingSuggestions && filteredSightseeingLocations.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                      {filteredSightseeingLocations.map((location, index) => (
                        <button
                          key={index}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleSightseeingSelect(location)}
                        >
                          <strong>{location.placeName}</strong>
                          <small className="d-block text-muted">{location.country}</small>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Activity Type</label>
                  <select
                    className="form-select"
                    name="activityType"
                    value={values.activityType}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Activity Type</option>
                    <option value="City Tour">City Tour</option>
                    <option value="Adventure">Adventure Activity</option>
                    <option value="Cultural">Cultural Experience</option>
                    <option value="Wildlife">Wildlife Safari</option>
                    <option value="Beach">Beach Activity</option>
                    <option value="Museum">Museum Visit</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="sightseeingDate"
                    value={values.sightseeingDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Adults</label>
                  <input
                    type="number"
                    className="form-control"
                    name="adults"
                    value={values.adults}
                    onChange={handleNumberChange}
                    min="1"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Children</label>
                  <input
                    type="number"
                    className="form-control"
                    name="children"
                    value={values.children}
                    onChange={handleNumberChange}
                    min="0"
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Requirements</label>
                  <textarea
                    className="form-control"
                    name="requirements"
                    value={values.requirements}
                    onChange={handleInputChange}
                    placeholder="Any specific requirements, timing preferences, guide requirements, etc."
                    rows="2"
                  />
                </div>
              </div>
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <MarketingTabs pageName="LEAD"></MarketingTabs>
              </div>
              <div className="card-body">
                <div className="col-12 pb-2 fs-5">Leads Management</div>
                <div className="row g-3">
                  <div className="col-xl-4 col-lg-6">
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Search by Name, Email, or Phone..."
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-xl-2 col-lg-3">
                    <select
                      name="filterStatus"
                      value={filterStatus}
                      onChange={(e) => setFilterStatus(e.target.value)}
                      className="form-select"
                    >
                      <option value="">All Status</option>
                      {leadStatusOptions.map((status, index) => (
                        <option key={index} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-xl-2 col-lg-3">
                    <div className="hstack gap-2">
                      <button className="btn btn-danger" onClick={handleReset}>
                        <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                        Reset
                      </button>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-12">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        className="btn btn-primary"
                        onClick={handleAddShow}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add
                        Lead
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                {isLoadingData ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading leads...</p>
                  </div>
                ) : (
                  <>
                    <div className="table-responsive table-card mb-4">
                      <table className="table align-middle table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th scope="col" style={{ width: "50px" }}>
                              S.No
                            </th>
                            <th scope="col">Lead Source</th>
                            <th scope="col">Customer</th>
                            <th scope="col">Requirement</th>
                            <th scope="col">Follow Up</th>
                            <th scope="col">Status</th>
                            <th scope="col" style={{ width: "180px" }}>
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.leadId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <td>
                                  <div className="d-flex align-items-center gap-1">
                                    <SourceIcon sourceName={v.sourceName} />
                                    <span
                                      className={`badge ${getEnquiryTypeColor(
                                        v.enquiryType
                                      )} p-2`}
                                    >
                                      {v.enquiryType || "GENERAL"}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <h5 className="fs-14 mb-1">
                                        <Link
                                          to="#"
                                          className="text-dark"
                                          onClick={() => showViewDetails(v)}
                                        >
                                          {v.name}
                                        </Link>
                                      </h5>
                                      <p className="text-muted mb-0">
                                        <i className="ri-mail-line me-1"></i>
                                        {v.email}
                                      </p>
                                      <p className="text-muted mb-0">
                                        <i className="ri-phone-line me-1"></i>
                                        {v.phoneNumber}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td
                                  className="truncate-text"
                                  style={{ maxWidth: "150px" }}
                                >
                                  {v.description || "No description provided"}
                                </td>
                                <td>
                                  {v.callBack &&
                                  v.callBack !== "0001-01-01T00:00:00" ? (
                                    <>
                                      {moment(v.callBack).format("DD MMM YYYY")}
                                      <small className="text-muted d-block">
                                        {moment(v.callBack).format("hh:mm A")}
                                      </small>
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  <span
                                    className={getStatusColor(v.leadStatus)}
                                  >
                                    {v.leadStatus}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <button
                                      className="btn btn-sm btn-soft-info"
                                      onClick={() => showViewDetails(v)}
                                      title="View Details"
                                    >
                                      <i className="ri-eye-fill"></i>
                                    </button>
                                    {v.leadStatus?.toLowerCase() !==
                                      "closed" && (
                                      <>
                                        <button
                                          className="btn btn-sm btn-soft-warning"
                                          onClick={() => showEditDetails(v)}
                                          title="Edit Lead"
                                        >
                                          <i className="ri-pencil-fill"></i>
                                        </button>
                                       <button
                    className="btn btn-sm btn-soft-primary"
                    onClick={() => {
                        setViewRecord(v); // Sets the lead context
                        setShowChatModal(true); // Opens the modal we define below
                    }}
                    title="Lead Discussion"
                >
                    <i className="ri-chat-3-line"></i>
                </button>
                                        <button
                                          className="btn btn-sm btn-soft-success"
                                          onClick={() => handleWhatsappClick(v)}
                                          title="Share via WhatsApp"
                                        >
                                          <i className="ri-whatsapp-line"></i>
                                        </button>
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center py-4">
                                <div className="text-muted">
                                  <i className="ri-search-line display-5"></i>
                                  <h5 className="mt-2">No Leads Found</h5>
                                  <p className="mb-0">
                                    {debouncedSearchKeyword || filterStatus
                                      ? "Try adjusting your search or filter criteria."
                                      : "No leads available. Add a new lead to get started."}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {lists.length > 0 && (
                      <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                        <div className="flex-shrink-0">
                          <div className="text-muted">
                            Showing{" "}
                            <span className="fw-semibold">{lists.length}</span>{" "}
                            of{" "}
                            <span className="fw-semibold">{totalRecords}</span>{" "}
                            Results
                          </div>
                        </div>
                        <ul className="pagination pagination-separated pagination-sm mb-0">
                          <li
                            className={`page-item ${
                              pageNumber === 1 ? "disabled" : ""
                            }`}
                            onClick={() =>
                              pageNumber > 1 && GetPageData(pageNumber - 1)
                            }
                          >
                            <Link to="#" className="page-link">
                              Previous
                            </Link>
                          </li>
                          {renderPageNumbers()}
                          <li
                            className={`page-item ${
                              pageNumber === totalPages ? "disabled" : ""
                            }`}
                            onClick={() =>
                              pageNumber < totalPages &&
                              GetPageData(pageNumber + 1)
                            }
                          >
                            <Link to="#" className="page-link">
                              Next
                            </Link>
                          </li>
                        </ul>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {selectedPackageDetails && (
          <div
            style={{ position: "absolute", left: "-9999px", width: "210mm" }}
          >
            <div ref={pdfTemplateRef}>
              <PremiumModernTemplate
                packageData={selectedPackageDetails}
                user={user}
              />
            </div>
          </div>
        )}

        {/* Add/Edit Modal */}
        <Modal
          show={addShow}
          onHide={handleAddClose}
          centered
          size="lg"
          className="fade"
        >
          <Modal.Header className="bg-primary p-3">
            <Modal.Title className="text-white">
              {values.leadId === "00000000-0000-0000-0000-000000000000"
                ? "Add New Lead"
                : "Edit Lead"}
            </Modal.Title>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleAddClose}
              aria-label="Close"
            ></button>
          </Modal.Header>
          <form onSubmit={handleSubmit} noValidate>
            <Modal.Body>
              <div className="row g-3">
                <div className="col-md-4 mb-3">
                  <label htmlFor="name" className="form-label">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={values.name}
                    onChange={handleInputChange}
                    maxLength={45}
                    className={`form-control ${
                      errors.name === false ? "is-invalid" : ""
                    }`}
                    placeholder="Enter name"
                  />
                  {errors.name === false && (
                    <div className="invalid-feedback">
                      Please enter a valid name
                    </div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="phoneNumber" className="form-label">
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onChange={handleInputChange}
                    className={`form-control ${
                      errors.phoneNumber === false ? "is-invalid" : ""
                    }`}
                    placeholder="Enter phone number"
                    maxLength={14}
                  />
                  {errors.phoneNumber === false && (
                    <div className="invalid-feedback">
                      Please enter a valid phone number
                    </div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    name="email"
                    value={values.email}
                    onChange={handleInputChange}
                    maxLength={45}
                    className={`form-control ${
                      errors.email === false ? "is-invalid" : ""
                    }`}
                    placeholder="Enter email"
                  />
                  {errors.email === false && (
                    <div className="invalid-feedback">
                      Please enter a valid email
                    </div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="sourceName" className="form-label">
                    Source
                  </label>
                  <select
                    name="sourceName"
                    value={values.sourceName}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value={"Walk In"}>Walk In</option>
                    <option value={"Phone Call"}>Phone Call</option>
                    <option value={"General"}>General</option>
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="enquiryType" className="form-label">
                    Enquiry Type
                  </label>
                  <select
                    name="enquiryType"
                    value={values.enquiryType}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    {enquiryTypeOptions.map((type, index) => (
                      <option key={index} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="leadStatus" className="form-label">
                    Status
                  </label>
                  <select
                    name="leadStatus"
                    value={values.leadStatus || "NEW"}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    {getFilteredLeadStatus().map((status, index) => (
                      <option key={index} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                </div>
                {values.leadStatus?.toLowerCase().includes("follow up") && (
                  <div className="col-md-4 mb-3">
                    <label htmlFor="callBack" className="form-label">
                      Follow Up <span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      name="callBack"
                      value={
                        values.callBack
                          ? moment(values.callBack).format("YYYY-MM-DDTHH:mm")
                          : ""
                      }
                      min={moment().format("YYYY-MM-DDTHH:mm")}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="col-md-8 mb-3">
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <textarea
                    name="description"
                    value={values.description}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Enter description"
                    rows="2"
                    maxLength="300"
                  />
                </div>
              </div>

              {/* Enquiry Specific Fields */}
              {renderEnquirySpecificFields()}
            </Modal.Body>
            <Modal.Footer>
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleAddClose}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={btnLoading}
                >
                  {btnLoading
                    ? "Saving..."
                    : values.leadId === "00000000-0000-0000-0000-000000000000"
                    ? "Add Lead"
                    : "Update Lead"}
                </button>
              </div>
            </Modal.Footer>
          </form>
        </Modal>

        {/* Enhanced View Modal with Comments Section */}
       <Modal
    show={showViewModal}
    onHide={() => setShowViewModal(false)}
    centered
    size="lg"
    scrollable
    className="lead-detail-modal"
>
    <Modal.Header className="bg-light p-3" closeButton>
        <Modal.Title className="fs-16 text-primary fw-bold">
            <i className="ri-discuss-line me-1"></i> Lead Information & Discussion
        </Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-0">
        {viewRecord && (
            <div className="d-flex flex-column">
                {/* --- 1. LEAD HEADER --- */}
                <div className="p-3 bg-primary text-white">
                    <Row className="align-items-center">
                        <Col>
                            <h5 className="mb-1 text-white fw-bold">{viewRecord.name}</h5>
                            <div className="hstack gap-3 small">
                                <span><i className="ri-mail-line me-1"></i>{viewRecord.email || "N/A"}</span>
                                <span><i className="ri-phone-line me-1"></i>{viewRecord.phoneNumber}</span>
                            </div>
                        </Col>
                        <Col xs="auto" className="text-end">
                            <Badge bg="white" className="text-primary fs-12 p-2">{viewRecord.enquiryType || "PACKAGE"}</Badge>
                        </Col>
                    </Row>
                </div>

                <div className="p-3">
                    {/* --- 2. SERVICE DETAILS --- */}
                    <h6 className="text-muted text-uppercase fw-bold mb-3 small">Enquiry Details</h6>
                    <div className="border rounded-2 mb-3 bg-white">
                        <Row className="g-0">
                            {Object.entries(viewRecord.serviceDetails || {}).map(([key, value]) => (
                                <Col key={key} xs={6} md={4} className="p-2 border-bottom border-end">
                                    <small className="text-muted text-uppercase d-block" style={{ fontSize: '9px' }}>
                                        {key.replace(/([A-Z])/g, ' $1').trim()}
                                    </small>
                                    <span className="fw-bold small text-dark">{value?.toString() || 'N/A'}</span>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <div className="p-2 bg-light rounded-2 border-start border-4 border-info mb-4 small italic">
                        "{viewRecord.description || "No description provided."}"
                    </div>

                    {/* --- 3. COMMENTS HISTORY (From lead.history) --- */}
                    <h6 className="text-muted text-uppercase fw-bold mb-3 small">
                        <i className="ri-history-line me-1"></i> Discussion Timeline ({viewRecord.history?.length || 0})
                    </h6>
                    <div className="p-3 bg-light rounded-3" style={{ maxHeight: "300px", overflowY: "auto" }}>
                        {viewRecord.history && viewRecord.history.length > 0 ? (
                            <div className="acitivity-timeline">
                                {/* Order by date: Newest at bottom as per standard chat/comment feel */}
                                {viewRecord.history.map((item, index) => (
                                    <div className="d-flex mb-3" key={index}>
                                        <div className="flex-shrink-0">
                                            <div className="avatar-xs">
                                                <div className="avatar-title rounded-circle bg-soft-primary text-primary fw-bold">
                                                    {item.userName ? item.userName.charAt(0) : "U"}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1 ms-3 border-bottom pb-2">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <h6 className="mb-0 fw-bold small text-dark">{item.userName || "System"}</h6>
                                                <small className="text-muted" style={{fontSize: '10px'}}>{moment(item.createdDate).format("DD MMM, HH:mm")}</small>
                                            </div>
                                            <p className="text-muted mb-0 small">{item.message}</p>
                                            <Badge bg="info" className="mt-1" style={{fontSize: '9px'}}>{item.status}</Badge>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-4 text-muted small">
                                <i className="ri-chat-off-line display-6 opacity-25"></i>
                                <p className="mt-2">No discussion history yet.</p>
                            </div>
                        )}
                    </div>
                </div>

                {/* --- 4. INLINE ADD COMMENT --- */}


                <div className="p-3 border-top bg-white sticky-bottom">
                    <Form.Group>
                        <Form.Label className="small fw-bold text-muted">Post a Comment</Form.Label>
                        <InputGroup>
                            <Form.Control 
                                as="textarea" 
                                rows={2} 
                                placeholder="Type your update here..." 
                                value={commentText}
                                onChange={(e) => setCommentText(e.target.value)}
                                className="bg-light border-0 shadow-none"
                                style={{ resize: 'none' }}
                            />
                            <Button 
                                variant="primary" 
                                className="px-3"
                                onClick={handleViewModalCommentSubmit}
                                disabled={isAddingComment || !commentText.trim()}
                            >
                                {isAddingComment ? <Spinner animation="border" size="sm" /> : <i className="ri-send-plane-2-fill fs-18"></i>}
                            </Button>
                        </InputGroup>
                    </Form.Group>
                </div>
            </div>
        )}
    </Modal.Body>
    <Modal.Footer className="bg-light p-2">
        <Button variant="outline-danger" size="sm" onClick={() => setShowViewModal(false)}>Close</Button>
    </Modal.Footer>
</Modal>
        {/* Add Comment Modal - ONLY called when user wants to add a new comment */}
        {/* DISKUSSION / CHAT MODAL */}
<Modal
    show={showChatModal}
    onHide={() => setShowChatModal(false)}
    centered
    size="lg"
    className="fade"
>
    <Modal.Body className="p-0" style={{ height: "650px" }}>
        {viewRecord && (
            <LeadChat 
                leadId={viewRecord.leadId} 
                title={viewRecord.name} 
                user={user} 
                type="SUPPLIER" // Logged in as DMC
                onClose={() => setShowChatModal(false)} 
            />
        )}
    </Modal.Body>
</Modal>

        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />

        <SourceModal
          show={showSourceModal}
          onHide={() => setShowSourceModal(false)}
          onSourceCreated={handleSourceSubmit}
        />

        
      </div>

      {/* Share Modal */}
      <Modal
        show={showShareModal}
        onHide={handleCloseShareModal}
        size="xl"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-light">
          <Modal.Title>
            <div className="d-flex align-items-center">
              <i className="ri-whatsapp-line me-2 text-success"></i>
              <div>
                <h5 className="mb-0">
                  Share with {selectedLeadForShare?.name}
                </h5>
                <small className="text-muted">
                  Enquiry for: {selectedLeadForShare?.enquiryType}
                </small>
              </div>
            </div>
          </Modal.Title>
          {selectedLeadForShare?.enquiryType === "VISA" ? (
            <button
              className="btn btn-primary ms-3"
              onClick={() => setShowVisaSearchModal(true)}
            >
              Search Visas
            </button>
          ) : (
            <button
              className="btn btn-primary ms-3"
              onClick={handleGeneratePackage}
            >
              Generate New Package
            </button>
          )}
        </Modal.Header>
        <Modal.Body>
          {selectedLeadForShare?.enquiryType === "VISA" ? (
            <div className="row">
              <div className="col-md-7">
                <div className="customer-selection-container">
                  <div className="search-bar mb-3">
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ri-search-line"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search visas by country..."
                        value={visaSearchTerm}
                        onChange={handleVisaSearch}
                      />
                    </div>
                  </div>

                  {filteredVisas.length > 0 && (
                    <div className="list-group mb-3">
                      {filteredVisas.map((country) => (
                        <button
                          key={country.id}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleCountrySelect(country)}
                        >
                          <img
                            src={`https://flagcdn.com/w40/${country.flagSrc.toLowerCase()}.png`}
                            alt={country.name}
                            className="me-2"
                            style={{ width: "20px" }}
                          />
                          {country.name}
                        </button>
                      ))}
                    </div>
                  )}

                  {selectedCountry ? (
                    <div>
                      <h6 className="mb-3">
                        Available Visas for {selectedCountry.name}
                      </h6>
                      <div className="list-group">
                        {selectedCountry.visas.map((visa) => (
                          <button
                            key={visa.visaId}
                            type="button"
                            className={`list-group-item list-group-item-action ${
                              selectedVisa?.visaId === visa.visaId
                                ? "active"
                                : ""
                            }`}
                            onClick={() => handleVisaSelect(visa)}
                          >
                            <div className="d-flex w-100 justify-content-between">
                              <h5 className="mb-1 ">{visa.visaName}</h5>
                              <small>{parseFloat(visa.adultPrice)} INR</small>
                            </div>
                            <p className="mb-1">
                              Type: {visa.visaType} | Entry: {visa.entry}
                            </p>
                            <small>
                              Stay: {visa.stayPeriod} | Validity:{" "}
                              {visa.validity}
                            </small>
                          </button>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-5 bg-light rounded">
                      <i className="ri-passport-line display-4 text-muted mb-3"></i>
                      <h5 className="mt-2">Search for Visas</h5>
                      <p className="text-muted">
                        Enter a country name to search for available visas.
                      </p>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-5">
                <div className="campaign-details-container">
                  <h5 className="mb-3">
                    <i className="ri-edit-line me-1"></i> Compose Message
                  </h5>
                  {selectedVisa ? (
                    <div>
                      <div className="mb-3">
                        <label className="form-label">WhatsApp Message</label>
                        <textarea
                          className="form-control"
                          rows="10"
                          name="whatsappMessage"
                          value={whatsappMessage}
                          onChange={(e) => setWhatsappMessage(e.target.value)}
                          placeholder="Select a visa to generate a message..."
                        ></textarea>
                        <small className="text-muted">
                          Max 1000 characters
                        </small>
                      </div>
                      <div className="package-info-card p-3 border rounded bg-light">
                        <h6>Selected Visa Details</h6>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Name:</span>
                          <span>{selectedVisa?.visaName}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Country:</span>
                          <span>{selectedCountry.name}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Type:</span>
                          <span>{selectedVisa?.visaType}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Price:</span>
                          <span>
                            {parseFloat(selectedVisa?.adultPrice)} INR
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-5 d-flex flex-column align-items-center justify-content-center h-100 bg-light rounded">
                      <i className="ri-passport-line display-4 text-muted mb-3"></i>
                      <h5 className="mt-2">No Visa Selected</h5>
                      <p className="text-muted">
                        Please search and select a visa to compose a message.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-7">
                <div className="customer-selection-container">
                  <div className="search-bar mb-3">
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ri-search-line"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Search ${selectedLeadForShare?.enquiryType} packages...`}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  <div
                    className="list-group"
                    style={{ maxHeight: "450px", overflowY: "auto" }}
                  >
                    {isLoadingPackages ? (
                      <div className="text-center py-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : shareablePackages.length > 0 ? (
                      shareablePackages.map((pkg) => (
                        <a
                          key={pkg.packageId}
                          href="#"
                          className={`list-group-item list-group-item-action d-flex align-items-start ${
                            selectedPackage?.packageId === pkg.packageId
                              ? "active"
                              : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            handlePackageSelect(pkg);
                          }}
                        >
                          <img
                            src={
                              pkg.imageSrc ||
                              "https://via.placeholder.com/80x80?text=No+Image"
                            }
                            alt={pkg.packageName}
                            className="package-list-image me-3"
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />

                          <div className="flex-grow-1">
                            <div className="d-flex w-100 justify-content-between">
                              <h5 className="mb-1">{pkg.packageName}</h5>
                              <small className="text-nowrap">
                                {moment(pkg.startedDate).format("DD MMM YYYY")}
                              </small>
                            </div>
                            <p className="mb-1 text-muted">
                              {pkg.description?.substring(0, 80)}...
                            </p>
                            <strong className="text-success">
                              {pkg.currency} {pkg.price?.toLocaleString()}
                            </strong>
                          </div>
                        </a>
                      ))
                    ) : (
                      <div className="text-center py-5 bg-light rounded">
                        <i className="ri-dropbox-line display-4 text-muted mb-3"></i>
                        <h5 className="mt-2">No Packages Found</h5>
                        <p className="text-muted">
                          No packages match the "
                          {selectedLeadForShare?.enquiryType}" enquiry type.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-5">
                <div className="campaign-details-container">
                  <h5 className="mb-3">
                    <i className="ri-edit-line me-1"></i> Compose Message
                  </h5>
                  {selectedPackage ? (
                    <div>
                      <div className="mb-3">
                        <label className="form-label">WhatsApp Message</label>
                        <textarea
                          className="form-control"
                          rows="10"
                          name="whatsappMessage"
                          value={whatsappMessage}
                          onChange={(e) => setWhatsappMessage(e.target.value)}
                          placeholder="Select a package to generate a message..."
                        ></textarea>
                        <small className="text-muted">
                          Max 1000 characters
                        </small>
                      </div>
                      <div className="package-info-card p-3 border rounded bg-light">
                        <h6>Selected Package Details</h6>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Name:</span>
                          <span>{selectedPackage?.packageName}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Price:</span>
                          <span>
                            {selectedPackage?.currency}{" "}
                            {selectedPackage?.price.toLocaleString()}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Duration:</span>
                          <span>{selectedPackage?.duration}</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-5 d-flex flex-column align-items-center justify-content-center h-100 bg-light rounded">
                      <i className="ri-price-tag-3-line display-4 text-muted mb-3"></i>
                      <h5 className="mt-2">No Package Selected</h5>
                      <p className="text-muted">
                        Please select a package from the left to compose a
                        message.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleCloseShareModal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={handleSendWhatsapp}
            disabled={(!selectedPackageDetails && !selectedVisa) || isSending}
          >
            {isSending ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>{" "}
                Sending...
              </>
            ) : (
              <>
                <i className="ri-whatsapp-line me-2"></i> Send WhatsApp Message
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
      
      {/* Validation Modal - When date/time is NOT selected */}
      <Modal
        show={showFollowUpValidation}
        onHide={handleCloseValidationModal}
        centered
        size="sm"
      >
        <Modal.Header closeButton className="bg-danger text-white">
          <Modal.Title>
            <i className="ri-error-warning-line me-2"></i>
            Follow-up Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <i className="ri-calendar-close-line display-4 text-danger mb-3"></i>
            <h5 className="text-danger">Follow-up Date Missing</h5>
            <p className="mb-3">
              You have selected <strong>Follow Up</strong> status but haven't
              set a follow-up date and time.
            </p>
            <div className="alert alert-warning py-2">
              <small>
                <i className="ri-information-line me-1"></i>
                Please select a follow-up date and time to continue.
              </small>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleCloseValidationModal}
          >
            <i className="ri-edit-line me-2"></i>
            Set Follow-up Date
          </button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal - When date/time IS selected */}
      <Modal
        show={showFollowUpConfirm}
        onHide={handleCancelFollowUp}
        centered
        size="sm"
      >
        <Modal.Header closeButton className="bg-warning">
          <Modal.Title className="text-dark">
            <i className="ri-alarm-warning-line me-2"></i>
            Confirm Follow-up
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <i className="ri-calendar-check-line display-4 text-warning mb-3"></i>
            <h5>Follow-up Scheduled</h5>
            <p className="mb-2">You've set a follow-up for:</p>
            <div className="alert alert-info py-3">
              <div className="fw-bold fs-5">
                {moment(pendingFormData?.callBack).format("DD MMM YYYY")}
              </div>
              <div className="text-muted">
                at {moment(pendingFormData?.callBack).format("hh:mm A")}
              </div>
            </div>
            <p className="text-muted small mb-0">
              Are you sure you want to schedule this follow-up?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleCancelFollowUp}
            disabled={btnLoading}
          >
            <i className="ri-close-line me-2"></i>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleConfirmFollowUp}
            disabled={btnLoading}
          >
            {btnLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Saving...
              </>
            ) : (
              <>
                <i className="ri-check-line me-2"></i>
                Yes, Schedule Follow-up
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
      <style jsx>{`
        .lead-detail-modal .modal-content {
          border-radius: 8px;
          border: none;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }
        .detail-item {
          padding: 6px;
          background: #f8f9fa;
          border-radius: 5px;
          border-left: 3px solid #667eea;
          font-size: 0.85rem;
        }
        .comments-container::-webkit-scrollbar {
          width: 6px;
        }
        .comments-container::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 5px;
        }
        .comments-container::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 5px;
        }
        .comments-container::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
        .comment-card {
          font-size: 0.8rem;
        }
        .package-list-image {
          width: 80px;
          height: 80px;
          object-fit: cover;
          border-radius: 8px;
          flex-shrink: 0;
        }
      `}</style>
    </div>
  );
};

const PremiumModernTemplate = ({ packageData, user }) => {
  if (!packageData?.package) return <div>Loading package data...</div>;

  const { package: pkg } = packageData;

  const PageSection = ({ children }) => (
    <div style={{ pageBreakInside: "avoid", marginBottom: "15px" }}>
      {children}
    </div>
  );

  const SectionHeader = ({ title }) => (
    <h3
      style={{
        color: "#4A5568",
        borderLeft: "4px solid #667eea",
        paddingLeft: "12px",
        marginBottom: "15px",
        fontSize: "1.5rem",
        pageBreakBefore: "auto",
        pageBreakAfter: "avoid",
      }}
    >
      {title}
    </h3>
  );

  const BookingTable = ({ headers, data, renderRow }) => (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.9rem",
        }}
      >
        <thead>
          <tr>
            {headers.map((header, i) => (
              <th
                key={i}
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  textAlign: "left",
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{data.map(renderRow)}</tbody>
      </table>
    </div>
  );

  return (
    <div
      style={{
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        color: "#2D3748",
        padding: "10mm",
        width: "210mm",
        backgroundColor: "white",
      }}
    >
      <PageSection>
        <div
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            {user?.logo && (
              <img
                src={user.logo}
                alt="Company Logo"
                style={{
                  height: "50px",
                  background: "white",
                  padding: "5px",
                  borderRadius: "8px",
                }}
                crossOrigin="anonymous"
              />
            )}
            <div style={{ textAlign: "right", fontSize: "0.9rem" }}>
              <p style={{ margin: 0 }}>{pkg.contactName || user?.name}</p>
              <p style={{ margin: 0 }}>{pkg.contactEmail || user?.email}</p>
              <p style={{ margin: 0 }}>
                {pkg.contactPhoneNumber || user?.phoneNumber}
              </p>
            </div>
          </div>
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <h1
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                marginBottom: "10px",
              }}
            >
              {pkg.packageName}
            </h1>
            <p style={{ fontSize: "1.2rem", opacity: "0.9" }}>
              {pkg.destinationsCover}
            </p>
          </div>
        </div>

        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ flex: 2 }}>
            <img
              src={pkg.imageSrc}
              alt={pkg.packageName}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "12px",
              }}
              crossOrigin="anonymous"
            />
          </div>
          <div
            style={{
              flex: 1,
              background: "#F7FAFC",
              padding: "20px",
              borderRadius: "12px",
            }}
          >
            <h3
              style={{
                color: "#4A5568",
                borderBottom: "2px solid #667eea",
                paddingBottom: "10px",
                marginBottom: "20px",
              }}
            >
              Package Summary
            </h3>
            <p>
              <strong>Duration:</strong> {pkg.duration}
            </p>
            <p>
              <strong>Start Date:</strong>{" "}
              {moment(pkg.startedDate).format("MMMM Do, YYYY")}
            </p>
            <p>
              <strong>Destinations:</strong> {pkg.destinationsCover}
            </p>
            <p>
              <strong>Price:</strong> {pkg.price?.toLocaleString()}{" "}
              {pkg.currency}
            </p>
          </div>
        </div>
      </PageSection>

      <PageSection>
        <SectionHeader title="Overview" />
        <p style={{ lineHeight: "1.6" }}>{pkg.description}</p>
      </PageSection>

      {packageData.itineraries?.length > 0 && (
        <PageSection>
          <SectionHeader title="Itinerary" />
          {packageData.itineraries
            .slice()
            .sort((a, b) => new Date(a.date) - new Date(b.date))
            .map((item, index) => (
              <div
                key={index}
                style={{
                  borderLeft: "3px solid #667eea",
                  padding: "10px 20px",
                  marginBottom: "15px",
                  background: "#F7FAFC",
                  pageBreakInside: "avoid",
                }}
              >
                <h5 style={{ margin: "0 0 5px 0" }}>
                  {moment(item.date).format("MMMM Do, YYYY")} - {item.title}
                </h5>
                <p style={{ margin: "0 0 5px 0" }}>
                  <strong>Location:</strong> {item.location}
                </p>
                <p style={{ margin: "0 0 5px 0" }}>{item.description}</p>
                {item.meals && (
                  <small>
                    <strong>Meals:</strong> {item.meals}
                  </small>
                )}
                {item.note && (
                  <small style={{ display: "block" }}>
                    <strong>Note:</strong> {item.note}
                  </small>
                )}
              </div>
            ))}
        </PageSection>
      )}

      {(packageData.includes?.length > 0 ||
        packageData.excludes?.length > 0) && (
        <PageSection>
          <div style={{ display: "flex", gap: "30px" }}>
            {packageData.includes?.length > 0 && (
              <div style={{ flex: 1 }}>
                <SectionHeader title="What's Included" />
                <ul
                  style={{
                    listStyleType: "'✓ '",
                    paddingLeft: "20px",
                    margin: 0,
                  }}
                >
                  {packageData.includes.map((item, index) => (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {item.description}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {packageData.excludes?.length > 0 && (
              <div style={{ flex: 1 }}>
                <SectionHeader title="What's Excluded" />
                <ul
                  style={{
                    listStyleType: "'✗ '",
                    paddingLeft: "20px",
                    margin: 0,
                  }}
                >
                  {packageData.excludes.map((item, index) => (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {item.description}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </PageSection>
      )}

      {packageData.hotelBookings?.length > 0 && (
        <PageSection>
          <SectionHeader title="Hotel Bookings" />
          <BookingTable
            headers={["Hotel", "City", "Check-In", "Check-Out", "Room Type"]}
            data={packageData.hotelBookings}
            renderRow={(hotel, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#F7FAFC" : "white",
                }}
              >
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hotel.hotelName}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hotel.city}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {moment(hotel.checkInDate).format("MMM Do, YYYY")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {moment(hotel.checkOutDate).format("MMM Do, YYYY")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hotel.roomType}
                </td>
              </tr>
            )}
          />
        </PageSection>
      )}

      {packageData.flightBookings?.length > 0 && (
        <PageSection>
          <SectionHeader title="Flight Details" />
          {packageData.flightBookings.map((flight, index) => (
            <div
              key={index}
              style={{
                background: "#F7FAFC",
                border: "1px solid #ddd",
                padding: "15px",
                borderRadius: "8px",
                marginBottom: "15px",
                pageBreakInside: "avoid",
              }}
            >
              <h5 style={{ margin: "0 0 10px 0" }}>
                {flight.airline} - Flight {flight.flightNumber} (
                {flight.cabinClass})
              </h5>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>
                  <strong>From:</strong> {flight.departureCity} <br />{" "}
                  {moment(flight.departureDateTime).format(
                    "MMM Do, YYYY h:mm a"
                  )}
                </p>
                <p style={{ textAlign: "right" }}>
                  <strong>To:</strong> {flight.arrivalCity} <br />{" "}
                  {moment(flight.arrivalDateTime).format("MMM Do, YYYY h:mm a")}
                </p>
              </div>
            </div>
          ))}
        </PageSection>
      )}

      {packageData.sightSeeings?.length > 0 && (
        <PageSection>
          <SectionHeader title="Sightseeing" />
          <BookingTable
            headers={["Date", "Destination", "Attraction", "Description"]}
            data={packageData.sightSeeings}
            renderRow={(sight, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#F7FAFC" : "white",
                }}
              >
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {moment(sight.date).format("MMM Do, YYYY")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {sight.destination}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {sight.sightseeingName}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {sight.description}
                </td>
              </tr>
            )}
          />
        </PageSection>
      )}

      {packageData.transfers?.length > 0 && (
        <PageSection>
          <SectionHeader title="Transfers" />
          <BookingTable
            headers={["Date", "Pickup Time", "From", "To", "Vehicle"]}
            data={packageData.transfers}
            renderRow={(transfer, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#F7FAFC" : "white",
                }}
              >
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {moment(transfer.date).format("MMM Do, YYYY")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {transfer.pickupTime}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {transfer.fromLocation}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {transfer.toLocation}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {transfer.vehicleDetails}
                </td>
              </tr>
            )}
          />
        </PageSection>
      )}

      {packageData.termsandConditions?.length > 0 && (
        <PageSection>
          <SectionHeader title="Terms & Conditions" />
          {packageData.termsandConditions.map((term, index) => (
            <div
              key={index}
              style={{ marginBottom: "10px", pageBreakInside: "avoid" }}
            >
              <h5 style={{ marginBottom: "5px" }}>{term.title}</h5>
              <p style={{ fontSize: "0.9rem", color: "#4A5568" }}>
                {term.description}
              </p>
            </div>
          ))}
        </PageSection>
      )}
    </div>
  );
};

export default Lead;